<template>
    <span :class="'badge ' + badgeClass">
         {{ totalPax }} / {{ maxSize }}
    </span>
</template>

<script>
export default {
    props: {
        adults: {
            type: Number,
            required: true,
        },
        children: {
            type: Number,
            required: false,
        },
        maxSize: {
            type: Number,
            required: true,
        }
    },
    computed: {
        totalPax() {
            return this.adults + this.children
        },
        badgeClass() {
            if ( this.totalPax > this.maxSize ) {
                return 'badge-danger'
            } else {
                return 'badge-success'
            }
        },

    }
}
</script>